module.exports = __webpack_public_path__ + "static/Okera-501d5a80fe3c7fb5f6177d258c392f76.jpg";